// Generated by ReScript, PLEASE EDIT WITH CARE


function getActionsByRoleAndStatus(role, status) {
  switch (role.TAG | 0) {
    case /* BusinessAdmin */0 :
        switch (status) {
          case /* Active */0 :
              return /* [] */0;
          case /* Pending */1 :
              return {
                      hd: /* Discard */1,
                      tl: {
                        hd: /* Approve */0,
                        tl: /* [] */0
                      }
                    };
          case /* Scheduled */2 :
              return {
                      hd: /* Delete */2,
                      tl: /* [] */0
                    };
          
        }
    case /* CityAdmin */1 :
    case /* User */2 :
        return /* [] */0;
    
  }
}

export {
  getActionsByRoleAndStatus ,
  
}
/* No side effect */
